// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DesktopTitle_wrapper__306qQ","picker":"DesktopTitle_picker__3smah"};